import Vue from 'vue'
import Router from 'vue-router'

const Error404 = () => import('@/components/views/error-404');

const politicaCookies = () => import('@/components/views/politica-de-cookies');
const politicaPrivacidad = () => import('@/components/views/politica-de-privacidad');
const avisoLegal = () => import('@/components/views/aviso-legal');
const ethicalChanel = () => import("@/components/views/ethical-chanel");


const matarile = () => import('@/components/views/matarile');


Vue.use(Router)


import messages from '@/translations';

let en = messages.en.enlaces;
let es = messages.es.enlaces;

export const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'matarile',
      component: matarile,
      meta: {
        title: 'Matarile',
        description: 'Matarile'
      }
    },
    {
      path: es.politica_privacidad,
      alias: en.politica_privacidad,
      name: 'politica-de-privacidad',
      component: politicaPrivacidad,
      meta: {
        title: 'Protección de datos Risi',
        description: 'En Risi garantizamos la privacidad y protección de tus datos'
      }
    },
    {
      path: es.politica_cookies,
      alias: en.politica_cookies,
      name: 'politica-de-cookies',
      component: politicaCookies,
      meta: {
        title: 'Política de Cookies Risi',
        description: 'Descubre todos los detalles en información acerca de nuestra política de cookies'
      }
    },
    {
      path: es.aviso_legal,
      alias: en.aviso_legal,
      name: 'aviso-legal',
      component: avisoLegal,
      meta: {
        title: 'Aviso Legal de Matarile',
        description: ''
      }
    },
    {
      path: es.ethical_chanel,
      alias: en.ethical_chanel,
      name: 'ethical-chanel',
      component: ethicalChanel,
      meta: {
        title: 'Canal Ético de Matarile',
        description: ''
      }
    },
    {
      path: '*',
      redirect: '/'
    },
    {
      path: "/404",
      component: Error404
    }
    // {
    // 	path : "*",
    // 	component : Error404
    // }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
});


router.beforeEach((to, from, next) => {

  let meta;

  meta = to.meta;

  if (!!meta) {
    document.title = meta.title
    document.head.querySelector("[name=description]").content = meta.description;
  }

  next()
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js